module.exports = __webpack_public_path__ + "media/img/institutions/standard-plan-0f3c4f7e4558e01cd8e29fb0a9daab35.svg";